<template>
  <div class="container reset-box">
    <div v-if="validToken">
      <div class="reset-head">Reset password</div>
      <v-form
        v-if="!showLoader"
        class="password-field-padding"
        ref="form"
        @submit.prevent="resetPasswordCallBack"
        lazy-validation
      >
        <div class="row">
          <div class="col-sm-12">
            <v-text-field
              :append-icon="showIcon ? 'visibility_off' : 'visibility'"
              v-model="password"
              :type="showIcon ? 'password' : 'text'"
              name="input-10-1"
              label="New password *"
              :hint="hint"
              @click:append="showIcon = !showIcon"
              :error-messages="passwordErrors"
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <v-text-field
              v-model="repeatPassword"
              :append-icon="showIcon2 ? 'visibility_off' : 'visibility'"
              label="Confirm password *"
              :type="showIcon2 ? 'password' : 'text'"
              @click:append="showIcon2 = !showIcon2"
              :error-messages="repeatPasswordErrors"
            ></v-text-field>
          </div>
        </div>
        <div class="resend-button">
          <button class="btn btn-save">Submit</button>
        </div>
      </v-form>
      <div v-if="showLoader" class="mx-auto loader"></div>
    </div>
    <div class="reset-head" v-if="!validToken && !showLoader">
      <v-icon
        size="32"
        style="margin-right: 1.0rem; margin-bottom: .2rem; color: var(--button-delete-color)"
        >mdi-alert-box</v-icon
      ><span style="color: var(--button-delete-color)">Invalid Token</span>
      <div>
        <a
          class="btn btn-back"
          style="color:white;width:auto !important; margin-top:2.0rem"
          @click="goBack"
          ><b>Go Back</b></a
        >
      </div>
    </div>

    <popup-box
      v-on:box-closed="onClosing"
      v-on:button-clicked="onConfirmSuccess"
      v-on:resend-email="resendPasswordResetMail"
      v-bind="resetPopupProps"
      :key="check"
    ></popup-box>
  </div>
</template>

<script>
import * as SYSTEM_CONST from "../../globalConstants";
import { VALIDATE_TOKEN } from "../../Api/common_api";
import {
  required,
  minLength,
  maxLength,
  sameAs
} from "vuelidate/lib/validators";
import PopupBox from "../global-components/pop-up-box";
export default {
  name: "reset-password",
  components: { PopupBox },
  validations: {
    password: { required, minLength: minLength(8), maxLength: maxLength(12) },
    repeatPassword: { sameAsPassword: sameAs("password") }
  },
  data: function() {
    return {
      validToken: null,
      password: "",
      repeatPassword: "",
      showIcon: true,
      showIcon2: true,
      showLoader: false,
      resetPopupProps: {
        open: false,
        title: "",
        message: "",
        resendMail: false
      },
      hint: SYSTEM_CONST.REQUIRED_MESSAGE.PASSWORD_LENGTH,
      check: 0
    };
  },
  methods: {
    goBack() {
      this.$router.push({ name: "landingPage" }).catch(function() {});
    },
    resetPasswordCallBack: function() {
      const self = this;
      let route = this.$route;
      self.$v.$touch();
      const password = JSON.stringify({
        password: this.password,
        token: route.query.token
      });
      if (!self.$v.$anyError) {
        self.showLoader = true;
        this.$http({
          method: SYSTEM_CONST.METHOD.PUT,
          url: SYSTEM_CONST.BASE_URL.FORGOT_PASSWORD_API_URL,
          headers: {
            "content-type": SYSTEM_CONST.HEADERS.TYPE.APPLICATION_JSON
          },
          data: password
        })
          .then(function(response) {
            if (response.status === 200) {
              self.showLoader = false;
              self.resetPopupProps.open = true;
              self.resetPopupProps.message =
                SYSTEM_CONST.RESET_PASSWORD.SUCCESS;
              self.resetPopupProps.title = SYSTEM_CONST.POPUP.SUCCESS_MESSAGE;
              self.check++;
            } else {
              self.showLoader = false;
              self.resetPopupProps.open = true;
              self.resetPopupProps.message =
                SYSTEM_CONST.RESET_PASSWORD.FAILURE;
              self.resetPopupProps.title = SYSTEM_CONST.POPUP.FAILURE_MESSAGE;
              self.resetPopupProps.resendMail = true;
              self.check++;
            }
          })
          .catch(function() {
            self.showLoader = false;
            self.resetPopupProps.open = true;
            self.resetPopupProps.message = SYSTEM_CONST.RESET_PASSWORD.FAILURE;
            self.resetPopupProps.title = SYSTEM_CONST.POPUP.FAILURE_MESSAGE;
            self.resetPopupProps.resendMail = true;
            self.check++;
          });
      }
    },
    onClosing: function() {
      this.$router.push({ name: "landingPage" }).catch(function() {});
    },
    onConfirmSuccess: function() {
      this.$router.push({ name: "signin" }).catch(function() {});
    },
    resendPasswordResetMail: function(email) {
      const self = this;
      let data = JSON.stringify({
        email: email,
        email_type: 'forgotPassword'
      });
      self.resetPopupProps.open = false;
      self.check++;
      self.showLoader = true;
      self.$http({
          method: SYSTEM_CONST.METHOD.POST,
          url: SYSTEM_CONST.BASE_URL.RESEND_EMAIL_API_URL,
          headers: {
            "content-type": SYSTEM_CONST.HEADERS.TYPE.APPLICATION_JSON
          },
          data: data
        })
        .then(function(response) {
          if (response.status === 200) {
            self.showLoader = false;
            self.resetPopupProps.open = true;
            self.resetPopupProps.title = SYSTEM_CONST.POPUP.SUCCESS_MESSAGE;
            self.resetPopupProps.message = 'A reset password link has been sent successfully to your email account';
            self.resetPopupProps.resendMail = false;
            self.check++;
          } else {
            self.showLoader = false;
            self.resetPopupProps.open = true;
            self.resetPopupProps.title = SYSTEM_CONST.POPUP.FAILURE_MESSAGE;
            self.resetPopupProps.message = SYSTEM_CONST.RESEND_EMAIL.FAILURE;
            self.resetPopupProps.resendMail = false;
            self.check++;
          }
        })
        .catch(function() {
          self.showLoader = false;
          self.resetPopupProps.open = true;
          self.resetPopupProps.title = SYSTEM_CONST.POPUP.FAILURE_MESSAGE;
          self.resetPopupProps.message = SYSTEM_CONST.RESEND_EMAIL.FAILURE;
          self.resetPopupProps.resendMail = false;
          self.check++;
        });
    }
  },
  mounted() {
    let token = this.$route.query.token;
    let prefix = this.$route.query.prefix;
    const self = this;
    if (token) {
      self.showLoader = true;
      VALIDATE_TOKEN(token, prefix)
        .then(function(response) {
          self.showLoader = false;
          if (response.status === 202) {
            self.validToken = true;
          } else {
            self.validToken = false;
            self.resetPopupProps.open = true;
            self.resetPopupProps.message =
              "Your token has expired. Please resend a verification email for resetting your password.";
            self.resetPopupProps.title = "Token Expired!";
            self.resetPopupProps.resendMail = true;
            self.check++;
          }
        })
        .catch(function() {
          self.showLoader = false;
          self.validToken = false;
          self.resetPopupProps.open = true;
          self.resetPopupProps.message = SYSTEM_CONST.RESET_PASSWORD.FAILURE;
          self.resetPopupProps.title = SYSTEM_CONST.POPUP.FAILURE_MESSAGE;
          self.resetPopupProps.resendMail = true;
          self.check++;
        });
    }
  },
  computed: {
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.PASSWORD_LENGTH);
      !this.$v.password.maxLength &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.PASSWORD_LENGTH);
      !this.$v.password.required &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.PASSWORD);
      return errors;
    },
    repeatPasswordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.repeatPassword.sameAsPassword &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.PASSWORD_NOT_MATCH);
      return errors;
    }
  }
};
</script>

<style scoped>
.reset-box {
  max-width: 60rem;
  margin-top: 10rem;
  box-shadow: 0 0 0.2rem 0 rgba(0, 0, 0, 0.16);
}
.password-field-padding {
  padding: 2rem;
}
.reset-head {
  padding: 1.5rem;
  font-size: 2.5rem;
  text-align: center;
}
.resend-button {
  padding: 4rem 1.5rem;
  text-align: right;
  cursor: pointer;
}
.v-input {
  text-align: right !important;
}
</style>
